import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import amber from '@material-ui/core/colors/amber';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import { closeMessage } from '../redux/actions';
import { BANNER } from '../redux/types';

const Messages =  (props) => {
  const { variant, message, imageUrl, mobileImageUrl, link } = props.messages[0];
  const banner = variant === BANNER;
  const imgUrl = props.mobile ? mobileImageUrl : imageUrl;

  return(
    <>
    {!banner && <div className="container">
      <Message
        message={message}
        variant={variant}
        closeMessage={props.closeMessage}
      />
    </div>}
    {banner && <div>
      <Banner
        imageUrl={imgUrl}
        link={link}
        closeMessage={props.closeMessage}
      />
    </div>}
    </>
  )
}

const variantIcon = {
  SUCCESS: CheckCircleIcon,
  WARNING: WarningIcon,
  ERROR: ErrorIcon,
  INFO: InfoIcon,
  off: CheckCircleIcon
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 600,
  },
  snackbar: {
    margin: '8px 0',
    backgroundColor: '#ffa000',
  },
  SUCCESS: {
    backgroundColor: 'green',
  },
  ERROR: {
    backgroundColor: theme.palette.error.dark,
  },
  INFO: {
    backgroundColor: '#00a9ff',
  },
  WARNING: {
    backgroundColor: amber[700],
  },
  off: {
    visibility: 'hidden',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  action: {
    border: '2px solid rgba(255, 255, 255, 0.5)',
    color: '#fff',
    borderRadius: 7,
  },
}));

function Banner(props) {
  const { imageUrl, link, closeMessage } = props;
  const closeStyle = {position: 'absolute', top: 10, right: 10, cursor: 'pointer' }
  return (
    <div style={{position: 'relative'}}>
      <a href={link} style={{display: 'block'}}>
        <img src={imageUrl} alt="" target="_blank" style={{display: 'block'}}/>
      </a>
      <IconButton key="close" aria-label="Close" color="inherit" style={closeStyle} onClick={closeMessage}>
        <CloseIcon />
      </IconButton>
    </div>
  );
}

function Message (props) {
  const classes = useStyles();
  const { message, variant } = props;
  const Icon = variantIcon[variant];

  const onClose = () => {
    props.closeMessage();
  }

  return (
    <div className={classes.wrap}>
      <SnackbarContent
        className={clsx(classes[variant], classes.snackbar)}
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={<IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return { 
    messages: state.messages,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps, { closeMessage })(Messages);
